import { render, staticRenderFns } from "./AddReferralCode.vue?vue&type=template&id=2e118eb2"
import script from "./AddReferralCode.vue?vue&type=script&lang=js"
export * from "./AddReferralCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports